module.exports = __webpack_public_path__ + "static/media/padlock-white.520e77aa.svg";